"use client"

import {Component} from "react"
import {Mobile, Notebook, PC, Tablet} from "../../ReactiveMode"
import SectionTitle from "../../../components/common/SectionTitle"

class NewFamilyInformation extends Component {
    constructor(props) {
        super(props)
        // 기존 state 객체를 새로운 내용으로 업데이트합니다.
        this.state = {
            processSteps: [
                {
                    icon: "fas fa-church",
                    title: "새가족 등록",
                    description: "성실교회(홈페이지) 방문을 통해<br />교적성도로 등록해보세요.",
                },
                {
                    icon: "fas fa-book-bible",
                    title: "새가족 교육",
                    description: "새가족 교육을 통해 하나님과 성경을<br />알아가며 신앙생활에 대해 배워갑니다.",
                },
                {
                    icon: "fas fa-hands-helping",
                    title: "소그룹 모임",
                    description: "지역, 관심사 등 다양한 소그룹으로<br />교제합니다.",
                },
                {
                    icon: "fas fa-dove",
                    title: "세례와 봉사",
                    description: "세례는 온전한 그리스도인의 축복이며<br />봉사는 그리스도인의 기쁨입니다.",
                },
            ],
            educationCards: [
                {
                    icon: "fas fa-bridge",
                    title: "1주: 다리의 예화",
                    description: "기독교 신앙의 기본 개념을 다리의<br />예화를 통해<br />이해합니다.",
                },
                {
                    icon: "fas fa-heart",
                    title: "2주: 구원의 확신",
                    description: "예수 그리스도를 통한 구원의 확신에 대해 배웁니다.",
                },
                {
                    icon: "fas fa-seedling",
                    title: "3주: 새 생명",
                    description: "그리스도 안에서 새로운 생명을 얻는<br />의미와<br />변화에 대해 배웁니다.",
                },
                {
                    icon: "fas fa-book-bible",
                    title: "4주: 성경",
                    description: "성경의 중요성과 말씀을 통한<br />신앙생활에 대해 배웁니다.",
                },
                {
                    icon: "fas fa-praying-hands",
                    title: "5주: 기도",
                    description: "기도의 의미와 방법,<br />기도 생활의 중요성에 대해 배웁니다.",
                },
                {
                    icon: "fas fa-certificate",
                    title: "6주: 새가족 수료",
                    description: "5주 과정을 마치고 성실교회의 정식<br />교인으로<br />등록됩니다.",
                },
            ],
            contactItems: [
                {
                    icon: "fas fa-map-marker-alt",
                    title: "교육 장소",
                    description: "교육관 3층 새가족부실",
                },
                {
                    icon: "fas fa-user",
                    title: "새가족부 담당",
                    description: "김은배 장로",
                },
                {
                    icon: "fas fa-phone",
                    title: "연락처",
                    description: "031-877-5591",
                },
            ],
        }
    }

    renderProcessStep = (step, index) => {
        return (
            <div className="process-icon-step" key={index}>
                <div className="icon-circle">
                    <i className={step.icon}></i>
                    <div className="accent-dot"></div>
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description" dangerouslySetInnerHTML={{__html: step.description}}></p>
            </div>
        )
    }

    renderEducationCard = (card, index) => {
        return (
            <div className="education-card" key={index}>
                <div className="education-icon">
                    <i className={card.icon}></i>
                </div>
                <h4>{card.title}</h4>
                <p dangerouslySetInnerHTML={{__html: card.description}}></p>
            </div>
        )
    }

    renderContactItem = (item, index) => {
        return (
            <div className="contact-item" key={index}>
                <div className="contact-icon">
                    <i className={item.icon}></i>
                </div>
                <div className="contact-content">
                    <h4>{item.title}</h4>
                    <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                </div>
            </div>
        )
    }

    render() {
        const {processSteps, educationCards, contactItems} = this.state

        return (
            <section className="pf-page">
                <PC>
                    <section className="newfamily-content">
                        <div className="background">
                            <div className="layout">
                                <div className="department-content-center">
                                    <div className="department-intro-center">
                                        <p><b>성실교회</b>의 새가족이 되신 것을 진심으로 <b>환영</b>하며 <b>축복</b>합니다.</p>
                                        <p><strong>새가족이란?</strong></p>
                                        <div>
                                            처음 교회에 나오신 분들, 여러가지 사정으로 오랫동안 교회에 출석하지 못했다가 새로운마음으로 다시
                                            나오시게 된 분들, 교회를 다니시다가 오신 분들 모두를 '새가족'이라 부르고 있습니다.
                                        </div>
                                    </div>
                                </div>

                                <SectionTitle title="새가족 등록 및 교육 과정"/>
                                <div className="newfamily-process-icons">
                                    <div className="process-icons-grid">{processSteps.map(this.renderProcessStep)}</div>
                                </div>

                                <SectionTitle title="새가족 교육"/>
                                <div className="newfamily-education">
                                    <p className="education-intro">
                                        새가족 교육은 성실교회의 등록 교인이 되기 원하시는 분은 누구나 이수하셔야 하는 필수 과정이며, 새가족
                                        교육은 5주로 구성되어 있으며 6주 차에 수료를 하게 됩니다. 새가족 교육은 교육관 3층 새가족부실에서
                                        진행됩니다.
                                    </p>
                                    <div
                                        className="education-cards">{educationCards.map(this.renderEducationCard)}</div>
                                </div>

                                <SectionTitle title="문의 및 연락처"/>
                                <div className="newfamily-contact">
                                    <div className="contact-info">{contactItems.map(this.renderContactItem)}</div>
                                </div>
                            </div>
                        </div>
                    </section>
                </PC>

                <Notebook>
                    <section className="newfamily-content">
                        <div className="background">
                            <div className="layout">
                                <div className="department-intro-center">
                                    <p><b>성실교회</b>의 새가족이 되신 것을 진심으로 <b>환영</b>하며 <b>축복</b>합니다.</p>
                                    <p><strong>새가족이란?</strong></p>
                                    <div>
                                        <br/>
                                        처음 교회에 나오신 분들, 여러가지 사정으로 오랫동안 교회에 출석하지 못했다가 새로운마음으로 다시
                                        나오시게 된 분들, 교회를 다니시다가 오신 분들 모두를 '새가족'이라 부르고 있습니다.
                                    </div>
                                </div>

                                <SectionTitle title="새가족 등록 및 교육 과정"/>
                                <div className="newfamily-process-icons">
                                    <div className="process-icons-grid notebook-process-grid">
                                        {processSteps.map(this.renderProcessStep)}
                                    </div>
                                </div>

                                <SectionTitle title="새가족 교육"/>
                                <div className="newfamily-education">
                                    <p className="education-intro">
                                        새가족 교육은 성실교회의 등록 교인이 되기 원하시는 분은 누구나 이수하셔야 하는 필수 과정이며, 새가족
                                        교육은 5주로 구성되어 있으며 6주 차에 수료를 하게 됩니다. 새가족 교육은 교육관 3층 새가족부실에서
                                        진행됩니다.
                                    </p>
                                    <div
                                        className="education-cards"
                                        style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px"}}
                                    >
                                        {educationCards.map(this.renderEducationCard)}
                                    </div>
                                </div>

                                <SectionTitle title="문의 및 연락처"/>
                                <div className="newfamily-contact">
                                    <div
                                        className="contact-info"
                                        style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px"}}
                                    >
                                        {contactItems.map(this.renderContactItem)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Notebook>

                <Tablet>
                    <section className="newfamily-content">
                        <div className="background">
                            <div className="layout">
                                <div className="department-intro-center">
                                    <p><b>성실교회</b>의 새가족이 되신 것을 진심으로 <b>환영</b>하며 <b>축복</b>합니다.</p>
                                    <p><strong>새가족이란?</strong></p>
                                    <div>
                                        <br/>
                                        처음 교회에 나오신 분들, 여러가지 사정으로 오랫동안 교회에 출석하지 못했다가 새로운마음으로 다시
                                        나오시게 된 분들, 교회를 다니시다가 오신 분들 모두를 '새가족'이라 부르고 있습니다.
                                    </div>
                                </div>


                                <SectionTitle title="새가족 등록 및 교육 과정"/>
                                <div className="newfamily-process-icons">
                                    <div className="process-icons-grid tablet-process-grid">
                                        {processSteps.map(this.renderProcessStep)}
                                    </div>
                                </div>

                                <SectionTitle title="새가족 교육"/>
                                <div className="newfamily-education tablet-newfamily-education">
                                    <p className="education-intro">
                                        새가족 교육은 성실교회의 등록 교인이 되기 원하시는 분은 누구나 이수하셔야 하는 필수 과정이며, 새가족
                                        교육은 5주로 구성되어 있으며 6주 차에 수료를 하게 됩니다. 새가족 교육은 교육관 3층 새가족부실에서
                                        진행됩니다.
                                    </p>
                                    <div
                                        className="education-cards"
                                        style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "15px"}}
                                    >
                                        {educationCards.map(this.renderEducationCard)}
                                    </div>
                                </div>

                                <SectionTitle title="문의 및 연락처"/>
                                <div className="newfamily-contact tablet-newfamily-contact">
                                    <div
                                        className="contact-info"
                                        style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "15px"}}
                                    >
                                        {contactItems.slice(0, 2).map(this.renderContactItem)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Tablet>

                <Mobile>
                    <section className="newfamily-content">
                        <div className="background">
                            <div className="layout">
                                <div className="department-intro-center">
                                    <p><b>성실교회</b>의 새가족이 되신 것을 <br/> 진심으로 <b>환영</b>하며 <b>축복</b>합니다.</p>
                                    <p><strong>새가족이란?</strong></p>
                                    <div>
                                        <br/>
                                        처음 교회에 나오신 분들, 여러가지 사정으로 오랫동안 교회에 출석하지 못했다가 새로운마음으로 다시
                                        나오시게 된 분들, 교회를 다니시다가 오신 분들 모두를 '새가족'이라 부르고 있습니다.
                                    </div>
                                </div>


                                <SectionTitle title="새가족 등록 및 교육 과정"/>
                                <div className="newfamily-process-icons">
                                    <div className="process-icons-grid mobile-process-grid">
                                        {processSteps.map(this.renderProcessStep)}
                                    </div>
                                </div>

                                <SectionTitle title="새가족 교육"/>
                                <div className="newfamily-education">
                                    <div className="mobile-newfamily-education">
                                        <p className="education-intro">
                                            새가족 교육은 성실교회의 등록 교인이 되기 원하시는 분은 누구나 이수하셔야 하는 필수 과정입니다.
                                        </p>
                                        <div className="mobile-education-cards">
                                            {educationCards.map(this.renderEducationCard)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Mobile>
            </section>
        )
    }
}

export default NewFamilyInformation
